export enum BankCustomerTypes {
    Personal = "Personal",
    Business = "Business"
}
